import { render, staticRenderFns } from "./created-request-columns2.vue?vue&type=template&id=4443f69e"
import script from "./created-request-columns2.vue?vue&type=script&lang=js"
export * from "./created-request-columns2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports